import parsleyjs from 'parsleyjs';

$('form').parsley();